import { Link, useLocation } from 'react-router-dom';

interface HeaderProps {
  showHomeButton?: boolean;
}

const MovarLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 613.967 191.71" className="h-8 md:h-9 w-auto">
    <g id="RUNNING_MAN">
      <path fill="#0073ff" d="M146.97,0c-9.061,0-16.386,7.345-16.386,16.416s7.325,16.378,16.386,16.378,16.387-7.334,16.387-16.378S156.014,0,146.97,0Z" />
      <path fill="#0073ff" d="M111.029,68.966l20.475-26.953c1.047-1.378,1.134-3.259.218-4.728l-8.697-13.954c-.767-1.231-2.118-1.974-3.568-1.964l-37.534.263h0l-20.579-.015c-1.611-.001-2.327,2.025-1.073,3.036l5.767,4.65c.811.654,1.772,1.097,2.796,1.29l35.744,6.734-44.216,47.519L2.167,93.11c-2.015.286-2.875,2.721-1.487,4.21l5.684,6.095c1.125,1.206,2.708,1.879,4.357,1.852l56.18-.923c2.081-.034,4.115-.623,5.892-1.705l13.461-8.197,28.409,22.549c1.119.888,1.851,2.175,2.043,3.59l5.408,39.818c.255,1.877,1.858,3.278,3.753,3.278h2.894c2.086,0,3.779-1.687,3.787-3.773l.165-44.189c.009-2.28-.721-4.502-2.079-6.333l-24.787-33.41,5.184-7.008Z" />
    </g>
    <g>
      <path fill="#ffffff" d="M252.471,125.326l-19.369-35.042h-15.377v35.042h-20.996V26.706h46.132c20.552,0,33.267,13.455,33.267,31.789,0,17.299-11.09,26.762-21.735,29.275l22.327,37.556h-24.249ZM254.541,58.347c0-8.132-6.358-13.159-14.638-13.159h-22.178v26.614h22.178c8.28,0,14.638-5.027,14.638-13.455Z" />
      <path fill="#ffffff" d="M291.796,125.326V26.706h69.789v18.482h-48.793v20.7h47.758v18.482h-47.758v22.475h48.793v18.482h-69.789Z" />
      <path fill="#ffffff" d="M377.993,125.326V26.706h46.131c21.439,0,33.12,14.49,33.12,31.789,0,17.151-11.829,31.641-33.12,31.641h-25.136v35.19h-20.995ZM435.805,58.495c0-8.28-6.358-13.307-14.638-13.307h-22.179v26.466h22.179c8.28,0,14.638-5.027,14.638-13.159Z" />
      <path fill="#ffffff" d="M469.513,125.326V26.706h21.144v80.138h41.696v18.482h-62.839Z" />
      <path fill="#ffffff" d="M555.268,125.326v-40.365l-37.851-58.255h23.953l24.397,39.477,24.396-39.477h23.805l-37.704,58.255v40.365h-20.995Z" />
    </g>
    <g>
      <path fill="#0073ff" d="M232.209,190.971v-31.723l-12.566,31.723h-3.08l-12.628-31.723v31.723h-7.207v-41.086h10.163l11.212,28.212,11.149-28.212h10.164v41.086h-7.207Z" />
      <path fill="#0073ff" d="M246.379,170.459c0-12.258,8.685-21.251,21.005-21.251,12.257,0,21.005,8.993,21.005,21.251s-8.748,21.251-21.005,21.251c-12.32,0-21.005-8.993-21.005-21.251ZM280.997,170.459c0-8.501-5.359-14.845-13.613-14.845-8.316,0-13.613,6.345-13.613,14.845,0,8.439,5.297,14.845,13.613,14.845,8.254,0,13.613-6.407,13.613-14.845Z" />
      <path fill="#0073ff" d="M305.949,190.971l-16.139-41.086h8.193l12.442,33.201,12.443-33.201h8.192l-16.138,41.086h-8.993Z" />
      <path fill="#0073ff" d="M359.54,190.971l-3.018-7.946h-18.849l-3.017,7.946h-8.193l16.139-41.086h8.993l16.139,41.086h-8.193ZM347.097,157.092l-7.391,19.588h14.784l-7.392-19.588Z" />
      <path fill="#0073ff" d="M395.638,190.971l-9.054-15.338h-7.207v15.338h-7.207v-41.086h18.047c8.132,0,13.491,5.236,13.491,12.874,0,7.269-4.806,11.273-9.795,12.073l10.102,16.139h-8.378ZM396.316,162.697c0-3.942-2.957-6.468-7.022-6.468h-9.917v13.059h9.917c4.065,0,7.022-2.587,7.022-6.591Z" />
    </g>
  </svg>
);

const NAV = [
  { to: '/services', label: 'Services' },
  { to: '/movar-tools', label: 'Dev Lab' },
  { to: '/report', label: 'Demo Report' },
  { to: '/ai-policy', label: 'AI Policy' },
];

export function Header({ showHomeButton: _showHomeButton = true }: HeaderProps) {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-[rgba(19,27,48,0.7)] backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between gap-6">
        <Link to="/" aria-label="Movar Reply home" className="flex-shrink-0">
          <MovarLogo />
        </Link>
        <nav className="flex items-center gap-1">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`relative px-3 py-2 text-sm font-medium transition-colors ${
                isActive(item.to) ? 'text-primary' : 'text-white/70 hover:text-white'
              }`}
            >
              {item.label}
              {isActive(item.to) && (
                <span className="absolute left-3 right-3 -bottom-[17px] h-px bg-primary" aria-hidden="true" />
              )}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
